import { CreateEntityTabPage } from "../shared/CreateEntityTabPage";

export function CreateDistributorPage(): JSX.Element {
  return <CreateEntityTabPage entityType="distributor" />;
}
